import React from "react"

import Enum from "./Enum"

const Enums = ({ prefix, list }) => (
  <>
    {prefix}
    {' '}
    {list.map(Enum)}
  </>
)

export default Enums
